import { PTO_URL } from '@/api/pto/const'
import { createBaseResponseErrors } from '@/utils/errors/baseResponseErrors'
import { createBaseCRUDApi, createBaseFilesApi } from '@/api/base'

export const PTO_PLANNING_URL = `${PTO_URL}/planning`

const errors = createBaseResponseErrors('планирование', 'планирования')

export const PTOPlanningApi = {
  ...createBaseCRUDApi(PTO_PLANNING_URL, errors),
  ...createBaseFilesApi(PTO_PLANNING_URL)
}
